import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { trpc } from "@blis/trpc/react";

import { TestRunsPage } from "@/features/runs/routes/TestRuns";

export const Route = createLazyFileRoute("/_auth/_app/runs/")({
  component: memo(TestRunRoute),
});

function TestRunRoute() {
  const search = Route.useSearch();
  const { data, isPending } = trpc.runs.list.useQuery({
    take: 100,
    search: search.q,
    testType: search.testType,
    testSpec: search.testSpec,
    labs: search.labs,
  });

  return <TestRunsPage runs={data || []} isPending={isPending} />;
}
